import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import $ from 'jquery';

import Loginheader from '../Loginheader';
import Menu from '../Menu';
import * as Common from '../Common';
import Dialog from '../Dialog';
//import Ratemarquee from '../rate/Ratemarquee';
import '../../mcss/common.css';
import * as Picklist from "../Picklist";
import AsyncSelect from 'react-select/async';
import Master_individual_profile from "../master/Master_individual_profile";

function NewRequest_cn_vtm() {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    const [entityType, setEntityType] = useState("A");

    const [reqBranch, setReqBranch] = useState("0");
    const [ddReqBranchOptions, setDdReqBranchOptions] = useState([]);

    const [reqReference, setReqReference] = useState("A");

    const [reqAgent, setReqAgent] = useState("0");
    const [ddReqAgentOptions, setDdReqAgentOptions] = useState([]);

    const [reqAgentLocation, setReqAgentLocation] = useState("0");
    const [ddReqAgentLocationOptions, setDdReqAgentLocationOptions] = useState([]);

    const [reqRemitterType, setReqRemitterType] = useState("I");
    const [reqRemitterName, setReqRemitterName] = useState("");

    const [reqProduct, setReqProduct] = useState("TT");
    const [ddReqProductOptions, setDdReqProductOptions] = useState([]);

    const [reqProductType, setReqProductType] = useState(1);
    const [ddReqProductTypeOptions, setDdReqProductTypeOptions] = useState([]);

    const [reqIsd, setReqIsd] = useState("0");
    const [ddReqIsdOptions, setDdReqIsdOptions] = useState([]);

    const [reqPurpose, setReqPurpose] = useState("0");
    const [ddReqPurposeOptions, setDdReqPurposeOptions] = useState([]);

    const [reqBenCountry, setReqBenCountry] = useState("");
    const [ddReqBenCountryOptions, setDdReqBenCountryOptions] = useState([]);

    const [reqQuantity, setReqQuantity] = useState("");
    const [reqSellRate, setReqSellRate] = useState("");
    const [reqValDate, setReqValDate] = useState(new Date());
    const [reqPan, setReqPan] = useState("");
    const [reqNameOnPan, setReqNameOnPan] = useState("");
    const [reqPanRelation, setReqPanRelation] = useState("0");
    const [ddReqPanRelationOptions, setDdReqPanRelationOptions] = useState([]);
    const [reqPanOthRelation, setReqPanOthRelation] = useState("");

    const [reqItr2Year, setReqItr2Year] = useState("0");
    const [reqSourceOfFund, setReqSourceOfFund] = useState("S");
    const [reqDisbInstName, setReqDisbInstName] = useState("");
    const [reqDisbAmount, setReqDisbAmount] = useState("");

    const [reqNostroType, setReqNostroType] = useState("0");

    const [rdBank, setRdBank] = useState("Y");
    const [reqIssuer, setReqIssuer] = useState("0");
    const [ddReqIssuer, setDdReqIssuer] = useState([]);
    const [reqMobile, setReqMobile] = useState("");
    const [reqEmail, setReqEmail] = useState("");
    const [reqTenure, setReqTenure] = useState("TOM");
    const [reqRemitterAcctNo, setReqRemitterAcctNo] = useState("");
    const [reqRemitterAcctIfsc, setReqRemitterAcctIfsc] = useState("");

    const [reqRemitterBankCode, setReqRemitterBankCode] = useState("0");
    const [reqRemitterBankOptions, setDdReqRemitterBankOptions] = useState([]);


    const [reqRemark, setReqRemark] = useState("");

    const [userRight, setUserRight] = useState([]);

    const [panTCS, setPanTCS] = useState([]);

    const [reqRemitterDob, setReqRemitterDob] = useState(new Date());
    const [reqPanFatherName, setReqPanFatherName] = useState("");

    const [showConfirmBox, setShowConfirmBox] = useState(false);

    const [pickedCorporate, setPickedCorporate] = useState(null);
    const [pickedIndividual, setPickedIndividual] = useState(null);

    const [showIndividualForm, setShowIndividualForm] = useState(false);
    const [scrIndividual, setScrIndividual] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'NEWREQUEST'], function (result) {
                let resp = JSON.parse(result);
                if (resp.add === "1") {
                    setUserRight(resp);
                    setEntityType(sessionStorage.entityType);

                    if (sessionStorage.entityType === "B") {
                        Common.callApi(Common.apiUser, [sid, 'branchallowed'], function (result) {
                            let resp = JSON.parse(result);
                            setDdReqBranchOptions(resp);
                            if (resp.length === 2) {
                                setReqBranch(resp[1].value);
                            }
                        });
                    } else if (entityType === "A") {
                        setReqReference("A");
                        Common.callApi(Common.apiEntity, [sid, 'agentbranchlink', sessionStorage.entityId], function (result) {
                            let resp = JSON.parse(result);
                            setDdReqBranchOptions(resp.oneBranch);
                            setDdReqAgentOptions(resp.oneAgent);
                            setReqBranch(resp.oneBranch[0].value);
                            setReqAgent(resp.oneAgent[0].value);
                        });
                    } else {
                        navigate('/'); // no query right
                    }
                    Common.callApi(Common.apiProduct, [sid, 'ddlistjson'], function (result) {
                        setDdReqProductOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiProductType, [sid, 'ddlistjson'], function (result) {
                        setDdReqProductTypeOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiIsd, [sid, 'ddlistjson'], function (result) {
                        setDdReqIsdOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiPurpose, [sid, 'ddlistjsontt'], function (result) {
                        setDdReqPurposeOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiCountry, [sid, 'ddlistjson'], function (result) {
                        setDdReqBenCountryOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiPanRelation, [sid, 'ddlistjson'], function (result) {
                        setDdReqPanRelationOptions(JSON.parse(result));
                    });
                    Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                        setDdReqIssuer(JSON.parse(result));
                        if (entityType === "A") {
                            setReqIssuer("10");
                        }
                    });
                    Common.callApi(Common.apiCashFree, [sid, 'cashfreebanklist'], function (result) {
                        setDdReqRemitterBankOptions(JSON.parse(result));
                    });
                } else {
                    //console.log('enquiry list outer');
                    Common.callApi(Common.apiRight, [sid, 'all', 'ENQUIRYLIST'], function (result) {
                        //console.log('enquiry list inner');
                        //console.log(result);
                        let resp = JSON.parse(result);
                        if (resp.view === "1") {
                            navigate('/enquiry-status');
                        } else {
                            navigate('/');
                        }
                    });
                    // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, entityType]);

    function onChangeBranch(id) {
        setReqBranch(id);
        onChangeRefrence("S")
    }

    function onChangeRefrence(id) {
        if (id === "S") {
            setReqAgent("0");
        }
        setReqReference(id);
        if (id === "A") {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentall', reqBranch], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        } else {
            Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagent', 0], function (result) {
                setDdReqAgentOptions(JSON.parse(result));
            });
        }
    }

    function onChangeAgent(id) {
        setReqAgent(id);
        setReqAgentLocation("0");
        Common.callApi(Common.apiEntity, [sid, 'ddlistjsonagentlocation', 'A', id], function (result) {
            setDdReqAgentLocationOptions(JSON.parse(result));
        });
    }

    function resetForm() {
        if (entityType === "B") {

            setReqReference("S");
            setReqAgent("0");
        }
        setReqRemitterType("I");
        setReqRemitterName("");
        setReqProduct("TT");
        setReqProductType(1);
        setReqIsd("0");
        setReqPurpose("0");
        setReqBenCountry("");
        setReqQuantity("");
        setReqSellRate("");
        setReqValDate(new Date());
        setReqPan("");
        setReqNameOnPan("");
        setReqPanRelation("0");
        setReqPanOthRelation("");

        setReqItr2Year("0");
        setReqSourceOfFund("S");
        setReqDisbInstName("");
        setReqDisbAmount("");

        setReqNostroType("0");
        setRdBank("Y");
        // setReqIssuer("10");
        setReqRemark("");

        setReqMobile("");
        setReqEmail("");
        setReqRemitterBankCode("0");
        setReqRemitterAcctNo("");
        setReqRemitterAcctIfsc("");
        setRefreshCounter(refreshCounter + 1);
        setPickedCorporate(null);
        setPickedIndividual(null);
    }

    function saveData() {
        setShowConfirmBox(false);
        $('.loader').show();
        var isOk = 0;
        var msg = [], i = 0;
        Common.validatePan(reqPan, setReqPan);
        if (reqDisbAmount === "") {
            setReqDisbAmount("0");
        }
        if (reqSourceOfFund === "S") {
            setReqDisbInstName("");
            setReqDisbAmount("0");
        }

        // || !Common.validatePanFlag(reqPan)
        // || reqPan === ""

        if (entityType === "A") {
            if (reqBranch === "0" || (reqReference === "A" && reqAgent === "0")
                || reqRemitterName === ""
                || reqIsd === "0"
                || reqQuantity === "" || reqPurpose === "0"
                || (reqIssuer === "0" && rdBank === "Y")
                || reqNostroType === "0"
                || (reqSourceOfFund === "L" && (reqDisbInstName === "" || reqDisbAmount === ""))
                || reqBenCountry === ""
                || (reqAgent === "15" && reqAgentLocation === "0")

            ) {

                msg[i++] = Common.getMessage("MSG0006");
                msg[i++] = (reqBranch === "0" ? " Branch " : '');
                msg[i++] = (reqReference === "A" && reqAgent === "0" ? " Agent " : '');
                msg[i++] = (reqAgent === "15" && reqAgentLocation === "0" ? " Agent Location" : '');
                msg[i++] = (reqBenCountry === "" ? " Beneficiary Country " : '');
                msg[i++] = (reqRemitterName === "" ? " Remitter Name " : '');
                msg[i++] = (reqIsd === "0" ? " Currency " : '');
                msg[i++] = (reqQuantity === "" ? " Quantity " : '');
                //msg[i++] = (reqSellRate === "" ? " Sale Rate " : '');
                msg[i++] = (reqPurpose === "0" ? " Purpose " : '');
                //msg[i++] = (!Common.validatePanFlag(reqPan) ? "Invalid PAN" : '');
                // msg[i++] = (reqPanRelation === "0" ? "PAN Relationship" : '');
                msg[i++] = ((reqIssuer === "0" && rdBank === "Y") ? " Issuer Bank " : '');
                msg[i++] = (reqNostroType === "0" ? "Nostro Charges" : '');
                msg[i++] = ((reqSourceOfFund === "L" && reqDisbInstName === "") ? "Loan Institution Name" : '');
                msg[i++] = ((reqSourceOfFund === "L" && (reqDisbAmount === "" || reqDisbAmount * 1 <= 0)) ? "Loan Disbursment Amount" : '');

                isOk = 1;
                $('.loader').hide();
                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);
            }
        }
        if (entityType === "B") {
            if (reqBranch === "0" || (reqReference === "A" && reqAgent === "0")
                || reqIsd === "0"
                || reqQuantity === ""
                || (reqIssuer === "0" && rdBank === "Y")
                || (reqSourceOfFund === "L" && (reqDisbInstName === "" || reqDisbAmount === ""))
                || reqBenCountry === ""
                || (reqAgent === "15" && reqAgentLocation === "0")
            ) {
                msg[i++] = Common.getMessage("MSG0006");
                msg[i++] = (reqBranch === "0" ? " Branch " : '');
                msg[i++] = (reqReference === "A" && reqAgent === "0" ? " Agent " : '');
                msg[i++] = (reqAgent === "15" && reqAgentLocation === "0" ? " Agent Location" : '');
                msg[i++] = (reqBenCountry === "" ? " Beneficiary Country " : '');
                msg[i++] = (reqIsd === "0" ? " Currency " : '');
                msg[i++] = (reqQuantity === "" ? " Quantity " : '');
                msg[i++] = ((reqIssuer === "0" && rdBank === "Y") ? " Issuer Bank " : '');
                msg[i++] = ((reqSourceOfFund === "L" && reqDisbInstName === "") ? "Loan Institution Name" : '');
                msg[i++] = ((reqSourceOfFund === "L" && (reqDisbAmount === "" || reqDisbAmount * 1 <= 0)) ? "Loan Disbursment Amount" : '');
                isOk = 1;
                $('.loader').hide();
                setMsgText(Common.buildMessageFromArray(msg));
                setMsgBox(true);

            }
        }

        if (Common.showPickList && ((reqRemitterType === "I" && pickedIndividual == null) || (reqRemitterType === "C" && pickedCorporate == null))) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((reqRemitterType === "I" && pickedIndividual == null) ? " Please select individual" : '');
            msg[i++] = ((reqRemitterType === "C" && pickedCorporate == null) ? " Please select corporate" : '');
            isOk = 1;
            $('.loader').hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
            return;
        }

        if (isOk === 0) {
            var object1 = {
                reqBranch: reqBranch,
                reqReference: reqReference,
                reqAgent: reqAgent,
                reqRemitterType: reqRemitterType,
                reqRemitterName: reqRemitterName,
                reqProduct: reqProduct,
                reqProductType: reqProductType,
                reqIsd: reqIsd,
                reqPurpose: reqPurpose,
                reqBenCountry: reqBenCountry,
                reqQuantity: reqQuantity,
                reqSellRate: (reqSellRate === "" ? 0 : reqSellRate),
                reqValDate: Common.dateYMD(reqValDate),
                reqPan: reqPan,
                reqNameOnPan: reqNameOnPan,
                reqPanRelation: reqPanRelation,
                reqPanOthRelation: reqPanOthRelation,
                reqIssuer: reqIssuer,
                reqItr2Year: reqItr2Year,
                reqSourceOfFund: reqSourceOfFund,
                reqDisbInstName: reqDisbInstName,
                reqDisbAmount: reqDisbAmount,
                reqNostroType: reqNostroType,
                rdBank: rdBank,
                reqMobile: reqMobile,
                reqEmail: reqEmail,
                reqTenure: reqTenure,
                reqRemitterAcctNo: reqRemitterAcctNo,
                reqRemitterAcctIfsc: reqRemitterAcctIfsc,
                reqRemitterBankCode: reqRemitterBankCode,
                reqRemark: reqRemark,
                reqAgentLocation: reqAgentLocation,
                reqPanFatherName: reqPanFatherName,
                reqRemitterDob: Common.dateYMD(reqRemitterDob),
                pickedIndividual: pickedIndividual,
                pickedCorporate: pickedCorporate,
                showpicklist: Common.showPickList
            };

            Common.callApi(Common.apiNewRequest, [sid, 'save', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                $('.loader').hide();
                if (resp.err === "") {
                    setMsgText(resp.msg);
                    setMsgBox(true);
                    resetForm();
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
            });
        }
    }

    function onClickSubmit() {
        setReqSellRate((reqSellRate === "" ? 0 : reqSellRate));
        if (reqPan === "") {
            setShowConfirmBox(true);
        } else {
            $('.loader').show();
            var object1 = {
                reqPan: reqPan
            }
            Common.callApi(Common.apiNewRequest, [sid, 'getpantcs', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                //console.log('get pan tcs : ' + result);
                if (resp.err === "") {
                    setPanTCS(resp);
                    setShowConfirmBox(true);
                } else {
                    setMsgText(resp.err);
                    setMsgBox(true);
                }
                $('.loader').hide();
            });
        }
    }

    const handleRemitterTypeChange = (v) => {
        setReqRemitterType(v);
        setPickedCorporate(null);
        setPickedIndividual(null);
    }

    const handleCorporateValue = (value) => {
        setPickedCorporate(value);
        var val = value.id.split("^");
        setReqRemitterName(val[8]);
    }

    const handleIndividualValue = (value) => {
        setPickedIndividual(value);
        var val = value.id.split("^");
        setReqRemitterName(val[3]);
    }

    const newIndividual = (btnype) => {
        setShowIndividualForm(true);
        if (btnype === "E" && pickedIndividual != null) setScrIndividual("E");
        else setScrIndividual("A");
    }

    const hideIndividualProfile = (val, individualsrno) => {
        setShowIndividualForm(val);
        if (individualsrno > 0) {
            const obj = {
                individualsrno: individualsrno,
                type: "PURCHASE"
            }
            Common.callApi(Common.apiIndividualProfile, [sid, "individualidfrompicklist", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                console.log("RESPONSE IS  ", resp);
                const desc = resp.desc.split("^");
                if (resp.id === "") setPickedIndividual(null);
                else handleNewIndiviualChange({ ...resp, desc: `${desc.slice().join("  ^  ")}` });
                // `${desc.slice(0, 3).join(" ")} ^ ${desc[3]} ^ ${desc.slice(4, 7).join(" ")}  ^    ${desc[7]}`
            });
        }
    }

    const handleNewIndiviualChange = (value) => {
        setPickedIndividual(value);
        var id = value.id.split("^");
        setReqRemitterName(id[3]);
        // setNIndivualSrno(id[1]);
        // setIndividualSelected(1);
        // setNCDFNum("");
    }

    // <Ratemarquee></Ratemarquee>
    return (
        <>
            <Loginheader></Loginheader>

            <Menu></Menu>

            <Container fluid>
                <Row>
                    <Col>
                        <h1>Request Details</h1>
                    </Col>
                </Row>
                <Row>
                    <Col >
                        {userRight.add === "1" ?
                            <Form>
                                <Row>
                                    <Col className='col-md-3'>
                                        <Form.Group>
                                            <Form.Label>Branch<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqBranch}
                                                onChange={(e) => onChangeBranch(e.target.value)}
                                                disabled={entityType === 'A' || ddReqBranchOptions.length === 2} >
                                                {ddReqBranchOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3'>
                                        <Form.Group >
                                            <Form.Label>Reference<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqReference}
                                                onChange={(e) => onChangeRefrence(e.target.value)}
                                                disabled={entityType === 'A'} >
                                                <option value="S">Self</option>
                                                <option value="A">Agent</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    {reqReference === "A" ?
                                        <>
                                            <Col className='col-md-3'>
                                                <Form.Group>
                                                    <Form.Label>Agent<span className="mandatory">*</span></Form.Label>
                                                    <Form.Select
                                                        value={reqAgent}
                                                        onChange={(e) => onChangeAgent(e.target.value)}
                                                        disabled={entityType === 'A'} >
                                                        {ddReqAgentOptions.map((res) =>
                                                            <option key={res.value} value={res.value}>{res.name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            {
                                                reqAgent * 1 > 0 ? <>
                                                    <Col className='divHide'>
                                                        <Form.Group>
                                                            <Form.Label>Agent Location</Form.Label>
                                                            <Form.Select
                                                                value={reqAgentLocation}
                                                                onChange={(e) => setReqAgentLocation(e.target.value)}
                                                                disabled={entityType === 'A'} >
                                                                {ddReqAgentLocationOptions.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </> : <>
                                                    <Col></Col>
                                                </>
                                            }

                                        </>
                                        : <>
                                            <Col></Col>
                                            <Col></Col>
                                        </>
                                    }

                                </Row>
                                <Row>
                                    <Col className='col-md-3'>
                                        <Form.Group>
                                            <Form.Label>Product<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqProduct}
                                                onChange={(e) => setReqProduct(e.target.value)}  >
                                                <option value="CNCARD">CNCARD</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col className='col-md-3'>
                                        <Form.Group >
                                            <Form.Label>Inovice Amount<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Quantity" maxLength={10}
                                                onChange={(e) => Common.validateDecValue(e.target.value, setReqQuantity)}
                                                value={reqQuantity} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className='divHide'>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Beneficiary Country<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqBenCountry}
                                                onChange={(e) => setReqBenCountry(e.target.value)}  >
                                                {ddReqBenCountryOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Bank </Form.Label>
                                            <Form.Select
                                                value={rdBank}
                                                onChange={(e) => setRdBank(e.target.value)}
                                                disabled={true}

                                            >
                                                <option value="Y">Yes</option>
                                                <option value="N">No</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {rdBank === "Y" ?
                                            <Form.Group >
                                                <Form.Label>Bank<span className="mandatory">*</span></Form.Label>
                                                <Form.Select
                                                    value={reqIssuer}
                                                    onChange={(e) => setReqIssuer(e.target.value)}  >
                                                    {ddReqIssuer.map((res) =>
                                                        <option key={res.value} value={res.value}>{res.name}</option>
                                                    )}
                                                </Form.Select>
                                            </Form.Group>
                                            : null
                                        }
                                    </Col>

                                </Row>
                                <Row className='divHide'>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Currency<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqIsd}
                                                onChange={(e) => setReqIsd(e.target.value)}  >
                                                {ddReqIsdOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Quantity<span className="mandatory">*</span></Form.Label>
                                            <Form.Control type="text" placeholder="Quantity" maxLength={10}
                                                onChange={(e) => Common.validateDecValue(e.target.value, setReqQuantity)}
                                                value={reqQuantity} autoComplete="off" />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Tenure of booking<span className="mandatory">*</span></Form.Label>
                                            <Form.Select
                                                value={reqTenure}
                                                onChange={(e) => setReqTenure(e.target.value)} >
                                                <option value="TOM">TOM</option>
                                                <option value="CASH">CASH</option>
                                                <option value="SPOT">SPOT</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Purpose {entityType === "A" ? <span className="mandatory">*</span> : null} </Form.Label>
                                            <Form.Select
                                                value={reqPurpose}
                                                onChange={(e) => setReqPurpose(e.target.value)}  >
                                                <input type="text" />
                                                {ddReqPurposeOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className='divHide'>
                                    <Col className='col-md-3'>
                                        <Form.Group>
                                            <Form.Label>Client Type{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                            <Form.Select
                                                value={reqRemitterType}
                                                onChange={(e) => handleRemitterTypeChange(e.target.value)}
                                            >
                                                <option value="I">Individual</option>
                                                <option value="C">Corporate</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    {
                                        (reqRemitterType === "I" && Common.showPickList) ?
                                            <Col className='col-md-6'>
                                                <Form.Group>
                                                    <Form.Label>Individual<span className='coloThemeRed'>*</span>
                                                        <span className='tranNewFormText' onClick={() => newIndividual("A")}>Not in list? Create New</span>
                                                        &nbsp;&nbsp;
                                                        <span className='tranNewFormText' onClick={() => newIndividual("E")}>Edit</span>
                                                    </Form.Label>
                                                    <AsyncSelect
                                                        cacheOptions={false}
                                                        defaultOptions={false}
                                                        value={pickedIndividual}
                                                        getOptionLabel={e => e.label + ' '}
                                                        getOptionValue={e => e.id}
                                                        loadOptions={Picklist.fetchIndividualProfilePicklist} // location = 1 , 2
                                                        onInputChange={Picklist.handleInputChange}
                                                        formatOptionLabel={Picklist.formatOptionLabel}
                                                        components={{ Menu: Picklist.menu }}
                                                        onChange={handleIndividualValue}
                                                    >
                                                    </AsyncSelect>
                                                </Form.Group>
                                            </Col>
                                            : (reqRemitterType === "C" && Common.showPickList) ?
                                                <Col className='col-md-6'>
                                                    <Form.Group>
                                                        <Form.Label>Ledger</Form.Label>
                                                        <AsyncSelect
                                                            cacheOptions={false}
                                                            defaultOptions={false}
                                                            value={pickedCorporate}
                                                            getOptionLabel={e => e.label + ' '}
                                                            getOptionValue={e => e.id}
                                                            loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, reqBranch)} // location = 1 , 2
                                                            onInputChange={Picklist.handleInputChange}
                                                            onChange={handleCorporateValue}
                                                        >
                                                        </AsyncSelect>
                                                    </Form.Group>
                                                </Col>
                                                : null
                                    }
                                    <Col className='col-md-3'>
                                        <Form.Group>
                                            <Form.Label>Client Name{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                            <Form.Control disabled={Common.showPickList} type="text" placeholder="Client Name" maxLength={50} autoComplete="off"
                                                value={reqRemitterName}
                                                onChange={(e) => Common.validateAlpNumPAN(e.target.value, setReqRemitterName)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className='divHide'>
                                        <Form.Group >
                                            <Form.Label>Type{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                            <Form.Select
                                                value={reqProductType}
                                                onChange={(e) => setReqProductType(e.target.value)}  >
                                                {ddReqProductTypeOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className='divHide'>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Client Bank</Form.Label>
                                            <Form.Select
                                                value={reqRemitterBankCode}
                                                onChange={(e) => setReqRemitterBankCode(e.target.value)}  >
                                                {reqRemitterBankOptions.map((res) =>
                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                )}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Client Bank Account Number</Form.Label>
                                            <Form.Control type="text" placeholder="Account Number" maxLength={50} autoComplete="off"
                                                value={reqRemitterAcctNo}
                                                onChange={(e) => Common.validateNumValue(e.target.value, setReqRemitterAcctNo)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Client Bank IFSC </Form.Label>
                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                value={reqRemitterAcctIfsc}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemitterAcctIfsc)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row className="divHide">
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Value Date<span className="mandatory">*</span></Form.Label>
                                            {
                                                /**
                                                 *   <Form.Control type="text" placeholder="Value Date" maxLength={10}
                                                className="dateTb"
                                                 value={reqValDate} onChange={(e)=>setReqValDate(e.target.value)}  autoComplete="off"/>
                                                onChange={(date) => setReqValDate(date)}
                                                onChange={(date) => Common.buildDateFormat(date, setReqValDate)}
                                                buildDateFormat
 
                                                 */
                                            }
                                            <DatePicker className="form-control"
                                                selected={reqValDate}
                                                onChange={(date) => setReqValDate(date)}
                                                isClearable
                                                dateFormat="dd/MM/yyyy"
                                                showYearDropdown
                                                showMonthDropdown
                                                useShortMonthInDropdown
                                                dropdownMode="select"
                                                peekNextMonth
                                                customInput={
                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <div className="divHide">
                                    {
                                        reqRemitterType === "I" || reqRemitterType === "C" ?
                                            <>
                                                <Row>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>PAN</Form.Label>
                                                            <Form.Control type="text" placeholder="PAN" maxLength={10} autoComplete="off"
                                                                value={reqPan} onChange={(e) => setReqPan(e.target.value)}
                                                                onBlur={(e) => Common.validatePan(e.target.value, setReqPan)} />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>Name On PAN</Form.Label>
                                                            <Form.Control type="text" placeholder="Name on PAN" maxLength={50} autoComplete="off"
                                                                value={reqNameOnPan}
                                                                onChange={(e) => Common.validateAlpNumPAN(e.target.value, setReqNameOnPan)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>Date of Birth<span className="mandatory">*</span></Form.Label>
                                                            <DatePicker className="form-control"
                                                                selected={reqRemitterDob}
                                                                onChange={(date) => setReqRemitterDob(date)}
                                                                isClearable={false}
                                                                dateFormat="dd/MM/yyyy"
                                                                showYearDropdown
                                                                showMonthDropdown
                                                                useShortMonthInDropdown
                                                                dropdownMode="select"
                                                                peekNextMonth

                                                                customInput={
                                                                    <input type="text" onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)} ></input>
                                                                }
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>Father's Name</Form.Label>
                                                            <Form.Control type="text" placeholder="Name on PAN" maxLength={50} autoComplete="off"
                                                                value={reqPanFatherName}
                                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqPanFatherName)}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>PAN Relationship</Form.Label>
                                                            <Form.Select
                                                                value={reqPanRelation}
                                                                onChange={(e) => setReqPanRelation(e.target.value)}  >
                                                                {ddReqPanRelationOptions.map((res) =>
                                                                    <option key={res.value} value={res.value}>{res.name}</option>
                                                                )}
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        {
                                                            (reqPanRelation === "11") ?
                                                                <Form.Group >
                                                                    <Form.Label>Other Relationship</Form.Label>
                                                                    <Form.Control type="text" placeholder="Other Relationship" maxLength={50}
                                                                        value={reqPanOthRelation} onChange={(e) => setReqPanOthRelation(e.target.value)} autoComplete="off" />
                                                                </Form.Group>
                                                                : null
                                                        }
                                                    </Col>
                                                    <Col></Col><Col></Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>ITR 2 Years{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                                            <Form.Select
                                                                value={reqItr2Year}
                                                                onChange={(e) => setReqItr2Year(e.target.value)}
                                                            >
                                                                <option value="1">Yes</option>
                                                                <option value="0">No</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group >
                                                            <Form.Label>Source of Fund{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                                            <Form.Select
                                                                value={reqSourceOfFund}
                                                                onChange={(e) => setReqSourceOfFund(e.target.value)}
                                                            >
                                                                <option value="S">Self</option>
                                                                <option value="L">Loan</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    {
                                                        reqSourceOfFund === "S" ?
                                                            <>
                                                                <Col>&nbsp;</Col><Col>&nbsp;</Col>
                                                            </>
                                                            :
                                                            <>
                                                                <Col>
                                                                    <Form.Group >
                                                                        <Form.Label>Disbursed Institution Name<span className="mandatory">*</span></Form.Label>
                                                                        <Form.Control type="text" placeholder="Institution" maxLength={50} autoComplete="off"
                                                                            value={reqDisbInstName}
                                                                            onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqDisbInstName)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                                <Col>
                                                                    <Form.Group >
                                                                        <Form.Label>Disbursed Amount<span className="mandatory">*</span></Form.Label>
                                                                        <Form.Control type="text" placeholder="Amount" maxLength={10} autoComplete="off"
                                                                            value={reqDisbAmount}
                                                                            onChange={(e) => Common.validateDecValue(e.target.value, setReqDisbAmount)}
                                                                        />
                                                                    </Form.Group>
                                                                </Col>
                                                            </>
                                                    }
                                                </Row>
                                            </>
                                            : null
                                    }
                                </div>
                                <Row className='divHide'>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Nostro Charges{entityType === "A" ? <span className="mandatory">*</span> : null}</Form.Label>
                                            <Form.Select
                                                value={reqNostroType}
                                                onChange={(e) => setReqNostroType(e.target.value)} >
                                                <option value="0" >Select</option>
                                                <option value="OUR">OUR</option>
                                                <option value="BEN">BEN</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Mobile No</Form.Label>
                                            <Form.Control type="text" placeholder="Mobile No" maxLength={10} autoComplete="off"
                                                value={reqMobile}
                                                onChange={(e) => Common.validateNumValue(e.target.value, setReqMobile)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control type="email" placeholder="Email" maxLength={100} autoComplete="off"
                                                value={reqEmail}
                                                onChange={(e) => setReqEmail(e.target.value)}
                                                onBlur={(e) => Common.validtateEmail(e.target.value, setReqEmail)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group >
                                            <Form.Label>Sale Rate</Form.Label>
                                            <Form.Control type="text" placeholder="Sale Rate" maxLength={10} autoComplete="off"
                                                value={reqSellRate}
                                                onChange={(e) => Common.validateDecValue(e.target.value, setReqSellRate)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='col-md-6'>
                                        <Form.Group controlId="txtRequestRemark">
                                            <Form.Label>Request Remark</Form.Label>
                                            <Form.Control as="textarea" rows={1} placeholder="Request Remark" maxLength={99} autoComplete="off"
                                                value={reqRemark}
                                                onChange={(e) => Common.validateAlpNumValue(e.target.value, setReqRemark)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>&nbsp;</Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Button variant="outline-success" size="sm" onClick={(e) => onClickSubmit()}>Submit</Button>&nbsp;
                                        <Button variant="outline-danger" size="sm" onClick={(e) => resetForm()}>Reset</Button>
                                    </Col>
                                </Row>
                            </Form>
                            : null}
                    </Col>
                </Row>
                <Row><Col>&nbsp;</Col></Row>
                <Row><Col>&nbsp;</Col></Row>
            </Container>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showConfirmBox}
                onHide={() => setShowConfirmBox(false)}

                centered
            >
                <Modal.Header>
                    <Modal.Title>
                        Cover Request Confirmation
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>
                        {
                            reqPan !== "" ?
                                <>
                                    <Row>
                                        <Col>
                                            TT/DD till date (INR) : {Math.round(panTCS.forex)}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            This : {1 * reqQuantity * reqSellRate}
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            Total : {Math.round(((1 * panTCS.forex) + (1 * reqQuantity * reqSellRate)))}
                                        </Col>
                                    </Row>
                                </> : null
                        }

                        <Row>
                            <Col>
                                Product : {reqProduct}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                ISD : {reqIsd}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Quantity : {reqQuantity}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Sale Rate :  {reqSellRate}
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                Tenure : {reqTenure}
                            </Col>
                        </Row>
                    </h3>
                    <Row className='divHide'>
                        <Col>
                            <b>Country : {reqBenCountry}</b>
                        </Col>
                        <Col>
                            <b>Bank : {reqIssuer} </b>
                        </Col>
                        <Col>
                            <b>Purpose : {reqPurpose} </b>
                        </Col>
                    </Row>
                    <Row>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-success" size="sm" onClick={(e) => saveData()} >I Confirm</Button>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Button variant="outline-danger" size="sm" onClick={(e) => setShowConfirmBox(false)} >No</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default NewRequest_cn_vtm;